import type { IconName, PrimeIconClass } from "../icon";
import type { StateMessageVariant } from "./types-state-message";

/** Ícone padrão de cada variante; o carregamento desenha o `Loading` do DS, sem ícone. */
export const STATE_MESSAGE_ICONS: Record<
  Exclude<StateMessageVariant, "loading">,
  IconName | PrimeIconClass
> = {
  error: "exclamation-triangle",
  // sem ícone no Figma (biblioteca não tem lock)
  forbidden: "pi pi-lock",
  empty: "inbox",
  info: "info-circle",
};
